import React, { lazy, Suspense } from 'react';
import Preloader from '@components-shared/preloader';
import { IEditorWrapperProps } from './types';

const Editor = lazy(() => import(/* webpackChunkName: "Editor" */ './HtmlEditor'));
const PreviewContent = lazy(() => import(/* webpackChunkName: "PreviewEditorContent" */ './HtmlEditorPreview'));

const HtmlEditorBase = (props: IEditorWrapperProps) => {
  const { value, onChange, isNeedPreview } = props;

  return (
    <div className="form__editor-wrapper">
      <Suspense fallback={<Preloader />}>
        <Editor onChange={onChange} value={value} />
        {isNeedPreview && <PreviewContent previewData={value} />}
      </Suspense>
    </div>
  );
};

export default HtmlEditorBase;
